import React from 'react';

import Banner from "./Banner"     
import ShopByCategory from "./ShopByCategory"     
import ShopByBrands from "./ShopByBrand"    
import ServiceRequestForm from "./ServiceRequest"      
import Sales from "./Sale"    
import TrendingItems from "./TrendingItems"     
import TopDiscountedProducts from "./TopDiscountedProducts"      
import Testimonials from "./Testimonials"    
import Footer from "../components/Footer"    
import Content1 from "../components/Content1"
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';


function Home() {
  const navigate = useNavigate();
  
  return (
    <div> 
      
      <Banner />  
      <ShopByCategory />         
      <Content1/>
      <ShopByBrands />    
      < ServiceRequestForm />      
 
      <Sales />   
      
      {/* Embroidery Designs Section */}
      <Container className="text-center my-5 py-4" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', borderRadius: '15px' }}>
        <h2 className="text-white mb-3">Embroidery Designs</h2>
        <p className="text-white mb-4">Explore our exclusive collection of embroidery designs</p>
        <Button 
          variant="light" 
          size="lg"
          onClick={() => navigate('/embroidery-designs')}
          className="px-5"
        >
          View All Designs
        </Button>
      </Container>
      
      < TrendingItems />     
      <TopDiscountedProducts />  
      <Testimonials />     
         
    </div>
  );
}

export default Home;
